import React from "react"
//@ts-ignore
import MusicCircleIcon from "../../../assets/admin_icons/music-circle.svg"

const ImageWithFallback = React.memo(
  ({
    coverFileUrl,
    overrideDefaultImage,
    overrideTargetUrl,
    width,
    height,
    doNotAllowRouting
  }: {
    coverFileUrl: string
    overrideDefaultImage?: string
    overrideTargetUrl?: string
    width?: number
    height?: number,
    doNotAllowRouting?: boolean
  }) => {
    const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
      e.currentTarget.src = overrideDefaultImage || MusicCircleIcon
      e.currentTarget.alt = "default-image"
    }
    const targetUrl = overrideTargetUrl || coverFileUrl
    const w = width || 40
    const h = height || 40
    const noAction = doNotAllowRouting || false
    return (
      <img
        src={coverFileUrl || "-"}
        alt="cover-file"
        className="rounded-[8px] no-parent-trigger"
        style={{
          minWidth: w,
          maxWidth: w,
          minHeight: h,
          maxHeight: h,
          cursor: noAction ? "default" : "pointer"
        }}
        width={w}
        height={h}
        onError={handleError}
        onClick={() => {
          if (!noAction) {
            window.open(targetUrl, "_blank")
          }
        }}
      />
    )
  }
)

export default ImageWithFallback
